module.exports = __webpack_public_path__ + "media/pdf/bezpieczni_w_ruchu_banner-bc60243c.png";